// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/app.scss
// module id = pfMu
// module chunks = 2